import React, { useRef, useState } from 'react';

const IconShare = () => (
  <svg width="22" height="22" className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    {/* Larger, bolder three-node connected-share icon. Uses currentColor so parent text color controls it */}
    <line x1="6" y1="12" x2="18" y2="6" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
    <line x1="6" y1="12" x2="18" y2="18" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
    <circle cx="6" cy="12" r="3" fill="currentColor" stroke="currentColor" strokeWidth="0.6" />
    <circle cx="18" cy="6" r="3" fill="currentColor" stroke="currentColor" strokeWidth="0.6" />
    <circle cx="18" cy="18" r="3" fill="currentColor" stroke="currentColor" strokeWidth="0.6" />
  </svg>
);

const WhatsappIcon = () => (
  <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.52 3.478A11.91 11.91 0 0012 0C5.373 0 .048 4.9.048 11.012c0 1.94.5 3.834 1.448 5.48L0 24l7.727-1.967A11.939 11.939 0 0012 22c6.627 0 11.952-4.9 11.952-11.012 0-2.98-1.16-5.74-3.432-7.51zM12 20.5c-1.4 0-2.77-.38-3.96-1.09l-.28-.17-4.59 1.17 1.19-4.48-.18-.29A8.03 8.03 0 013.98 11.01c0-4.45 3.6-8.06 8.02-8.06 2.14 0 4.15.85 5.65 2.4A7.97 7.97 0 0120 11.01C20 16.06 16 20.5 12 20.5z" />
    <path d="M17.6 14.2c-.3-.15-1.77-.87-2.04-.97-.28-.1-.48-.15-.68.15-.2.3-.77.97-.95 1.17-.18.2-.36.22-.67.07-.32-.15-1.36-.5-2.59-1.6-.96-.86-1.61-1.92-1.8-2.22-.18-.3-.02-.46.13-.61.13-.12.28-.32.42-.48.14-.15.18-.26.28-.43.1-.17.05-.33-.03-.47-.08-.14-.68-1.64-.93-2.25-.24-.58-.49-.5-.67-.51-.17-.01-.37-.01-.57-.01s-.47.07-.72.33c-.25.26-.96.94-.96 2.3 0 1.36.98 2.67 1.12 2.85.14.18 1.94 2.92 4.7 4.07 1.87.76 2.57.82 3.49.69.56-.08 1.77-.72 2.02-1.41.25-.69.25-1.28.18-1.41-.07-.13-.26-.2-.56-.35z" />
  </svg>
);

const FacebookIcon = () => (
  <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M22 12a10 10 0 10-11.5 9.9v-7h-2.3v-2.9h2.3V9.2c0-2.3 1.4-3.6 3.5-3.6 1 0 2 .08 2 .08v2.2h-1.1c-1.1 0-1.4.66-1.4 1.3v1.6h2.4l-.4 2.9h-2v7A10 10 0 0022 12z" />
  </svg>
);

const XIcon = () => (
  <svg className="w-4 h-4" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M24 4.56L19.44 12l4.56 7.44L20.33 24 15.78 16.56 11.22 24 8.01 21.24 12.56 13.8 8 6.36 11.21 3.6 15.78 11.04 20.33 3.6z" />
  </svg>
);

const ShareButton = ({ url, title }) => {
  const shareUrl = (provider) => {
    const encodedUrl = encodeURIComponent(url || window.location.href);
    const encodedTitle = encodeURIComponent(title || document.title || '');
    switch (provider) {
      case 'whatsapp':
        // For direct share links, prefer the web.whatsapp.com domain for desktop so it opens WhatsApp Web directly.
        // Mobile-specific schemes / intents are handled in the open() flow below.
        // Put the URL on a new line after the title so WhatsApp recognizes it as a link.
        return `https://web.whatsapp.com/send?text=${encodedTitle}%0A${encodedUrl}`;
      case 'facebook':
        return `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
      case 'x':
        // Use the `url` param for intent/tweet which ensures the URL is attached and clickable; keep title in text
        return `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`;
      default:
        return encodedUrl;
    }
  };

  const open = (provider) => {
    // Special handling for WhatsApp to prefer opening the native app on mobile
    if (provider === 'whatsapp') {
      const encodedUrl = encodeURIComponent(url || window.location.href);
      const encodedTitle = encodeURIComponent(title || document.title || '');
      const textParam = `${encodedTitle}%0A${encodedUrl}`;
  // For desktop fallback prefer WhatsApp Web; mobile will try native schemes first.
  const webUrl = `https://web.whatsapp.com/send?text=${textParam}`;
      const iosUrl = `whatsapp://send?text=${decodeURIComponent(textParam)}`;
      const intentUrl = `intent://send?text=${textParam}#Intent;package=com.whatsapp;scheme=whatsapp;end`;

      // Try best-effort native open on mobile, fallback to web URL after short delay
      try {
        const ua = navigator.userAgent || '';
        if (/Android/i.test(ua)) {
          // Android: use intent URI to directly open the app without the intermediate chooser when possible
          window.location.href = intentUrl;
          // If intent fails (browser doesn't support it), open web fallback in a new tab after a pause
          setTimeout(() => window.open(webUrl, '_blank', 'noopener,noreferrer'), 700);
        } else if (/iPhone|iPad|iPod/i.test(ua)) {
          // iOS: use whatsapp:// scheme
          window.location.href = iosUrl;
          setTimeout(() => window.open(webUrl, '_blank', 'noopener,noreferrer'), 700);
        } else {
          // Desktop: open WhatsApp Web directly
          window.open(webUrl, '_blank', 'noopener,noreferrer');
        }
      } catch (err) {
        console.error('WhatsApp open error, falling back to web share:', err);
        window.open(webUrl, '_blank', 'noopener,noreferrer');
      }
      return;
    }

    const u = shareUrl(provider);
    window.open(u, '_blank', 'noopener,noreferrer');
  };

  const btnRef = useRef(null);
  const [popoverPos, setPopoverPos] = useState({ top: 0, left: 0 });
  const [isOpen, setIsOpen] = useState(false);
  const closeTimer = useRef(null);

  const cancelClose = () => {
    if (closeTimer.current) {
      clearTimeout(closeTimer.current);
      closeTimer.current = null;
    }
  };

  const handleMouseEnter = () => {
    cancelClose();
    if (btnRef.current) {
      const rect = btnRef.current.getBoundingClientRect();
      setPopoverPos({
        top: rect.top + rect.height / 2 - 16,
        right: window.innerWidth - rect.left + 6,
      });
      setIsOpen(true);
    }
  };

  const handleMouseLeave = () => {
    closeTimer.current = setTimeout(() => {
      setIsOpen(false);
      setPopoverPos({ top: -9999, right: -9999 });
    }, 200);
  };

  const handlePopoverEnter = () => {
    cancelClose();
  };

  const handlePopoverLeave = () => {
    handleMouseLeave();
  };

  return (
    <div className="share-btn-wrap" title="Share" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <button ref={btnRef} className="share-main-btn text-red-700" aria-label="Share" onClick={(e) => e.stopPropagation()}>
        <IconShare />
      </button>
      <div
        className={`share-popover ${isOpen ? 'share-popover-visible' : ''}`}
        role="menu"
        style={isOpen ? { top: `${popoverPos.top}px`, right: `${popoverPos.right}px` } : {}}
        onMouseEnter={handlePopoverEnter}
        onMouseLeave={handlePopoverLeave}
      >
        <button onClick={(e) => { e.stopPropagation(); open('whatsapp'); }} className="share-mini-btn whatsapp" aria-label="Share on WhatsApp">
          <WhatsappIcon />
        </button>
        <button onClick={(e) => { e.stopPropagation(); open('facebook'); }} className="share-mini-btn facebook" aria-label="Share on Facebook">
          <FacebookIcon />
        </button>
        <button onClick={(e) => { e.stopPropagation(); open('x'); }} className="share-mini-btn x" aria-label="Share on X">
          <XIcon />
        </button>
      </div>
    </div>
  );
};

const CopyLinkIcon = () => (
  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export const InlineShareButtons = ({ url, title }) => {
  const [showToast, setShowToast] = useState(false);
  const shareUrl = encodeURIComponent(url || window.location.href);
  const shareTitle = encodeURIComponent(title || document.title || '');

  const open = (e, link) => {
    e.stopPropagation();
    e.preventDefault();
    window.open(link, '_blank', 'noopener,noreferrer');
  };

  const copyLink = (e) => {
    e.stopPropagation();
    e.preventDefault();
    navigator.clipboard.writeText(url || window.location.href);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 2000);
  };

  return (
    <div className="relative flex items-center gap-2">
      <button
        onClick={(e) => open(e, `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`)}
        className="w-6 h-6 flex items-center justify-center rounded-full bg-blue-600 text-white hover:bg-blue-700 transition-colors"
        aria-label="Share on Facebook"
      >
        <svg className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="currentColor"><path d="M22 12a10 10 0 10-11.5 9.9v-7h-2.3v-2.9h2.3V9.2c0-2.3 1.4-3.6 3.5-3.6 1 0 2 .08 2 .08v2.2h-1.1c-1.1 0-1.4.66-1.4 1.3v1.6h2.4l-.4 2.9h-2v7A10 10 0 0022 12z"/></svg>
      </button>
      <button
        onClick={(e) => open(e, `https://twitter.com/intent/tweet?url=${shareUrl}&text=${shareTitle}`)}
        className="w-6 h-6 flex items-center justify-center rounded-full bg-black text-white hover:bg-gray-800 transition-colors"
        aria-label="Share on X"
      >
        <svg className="w-3 h-3" viewBox="0 0 24 24" fill="currentColor"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
      </button>
      <button
        onClick={copyLink}
        className="w-6 h-6 flex items-center justify-center rounded-full bg-gray-600 text-white hover:bg-gray-700 transition-colors"
        aria-label="Copy link"
      >
        <CopyLinkIcon />
      </button>
      {showToast && (
        <div className="absolute -top-9 left-1/2 -translate-x-1/2 bg-gray-900 text-white text-xs px-3 py-1.5 rounded-lg shadow-lg whitespace-nowrap z-50 animate-fade-in">
          Link copied!
        </div>
      )}
    </div>
  );
};

export default ShareButton;
